import styled from 'styled-components'

import { MultiProgressBarStyled } from './MultiProgressBarStyled'
import { type IMultiProgressProps } from '../MultiProgress'
import { ProgressStyled } from '@ui/elements/Progress/styles/ProgressStyled'

interface IMultiProgressStyledProps
  extends Pick<IMultiProgressProps, 'height'> {}

export const MultiProgressStyled = styled.div<IMultiProgressStyledProps>`
  position: relative;
  width: 100%;

  ${(props) =>
    props.height
      ? typeof props.height === 'string'
        ? `height: ${props.height};`
        : `height: ${props.height}em;`
      : `height: 1em;`}

  .progress-bar-container {
    background: ${(props) => props.theme.colors.lightGrey};

    overflow: hidden;
    border-radius: 5px;

    width: 100%;
    height: 100%;

    display: flex;
    justify-content: flex-start;
  }
`
